const sixty = [
  {
    name: 'all-regions',
    type: '60',
    size: '60px'
  },
  {
    name: 'africa',
    type: '60',
    size: '60px'
  },
  {
    name: 'asia',
    type: '60',
    size: '60px'
  },
  {
    name: 'europe',
    type: '60',
    size: '60px'
  },
  {
    name: 'north-america',
    type: '60',
    size: '60px'
  },
  {
    name: 'oceania',
    type: '60',
    size: '60px'
  },
  {
    name: 'south-america',
    type: '60',
    size: '60px'
  }
];

export default sixty;


// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/sixty.js